/**
 * eQuote Design System - Typography
 */

import { Platform } from 'react-native';

export const fonts = {
  headline: Platform.select({ web: "'Be Vietnam Pro', sans-serif", default: 'BeVietnamPro' }),
  body:     Platform.select({ web: "'Inter', sans-serif", default: 'Inter' }),
  label:    Platform.select({ web: "'Inter', sans-serif", default: 'Inter' }),
} as const;

export const fontWeights = {
  regular:  '400' as const,
  medium:   '500' as const,
  semibold: '600' as const,
  bold:     '700' as const,
  extrabold: '800' as const,
  black:    '900' as const,
};

export const fontSizes = {
  xs:   10,
  sm:   12,
  md:   14,
  lg:   16,
  xl:   18,
  '2xl': 20,
  '3xl': 24,
  '4xl': 28,
  '5xl': 32,
} as const;

export const lineHeights = {
  tight:  1.2,
  snug:   1.4,
  normal: 1.5,
  relaxed: 1.6,
} as const;

export const letterSpacings = {
  tighter: -0.02,
  tight:   -0.01,
  normal:  0,
  wide:    0.02,
  wider:   0.06,
  widest:  0.1,
} as const;
